import React from 'react';

import Container from '../../StyledComponents/Container';
import { Page, PageSection } from '../../StyledComponents/Page';
import Loader from '../../StyledComponents/Loader';

const PageLoading = () => (
  <Page>
    <PageSection large>
      <Container>
        <Loader />
      </Container>
    </PageSection>
  </Page>
);

export default PageLoading;
